export default __webpack_public_path__ + "static/media/pressingstrikes.fe2dd26a.png";